import { Helpers } from '../../helpers';
import { IForecastSegmentType } from '../../interfaces/iforecast-segment-type';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastSegmentTypeBase {
  ForecastSegmentTypeId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  ForecastParameterDetails_ForecastSegmentType?: Array<ForecastParameterDetail> | null;
  TypeCurveParameters_ForecastSegmentType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastSegmentType) {
    if (item) {

      this.ForecastSegmentTypeId = item.ForecastSegmentTypeId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.ForecastParameterDetails_ForecastSegmentType = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastSegmentType);
      this.TypeCurveParameters_ForecastSegmentType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastSegmentType);
    }
  }
}